module.exports = __webpack_public_path__ + "static/img/alarm.191cba72.png";